export function PageLoading({ label, error }: { label: string; error?: string | null }) {
  if (error) return <main className="page-content"><p className="form-error">{error}</p></main>
  return <main className="page-content page-loading" role="status" aria-live="polite" aria-busy="true">
    <span className="page-loading-card">
      <span className="page-loading-spinner" aria-hidden="true" />
      <span className="page-loading-label">{label}</span>
    </span>
  </main>
}

export function LoadingIndicator({ label }: { label: string }) {
  return <div className="loading-indicator" role="status" aria-live="polite">
    <span className="page-loading-spinner" aria-hidden="true" />
    <span className="visually-hidden">{label}</span>
  </div>
}
